module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/369.f859f3fb.png";